// This file is automatically generated. Do not edit manually.

import { TaskTemplateItem } from "src/api/generated/postgres/db/types/tasks/tables/taskTemplateItem";
import { TaskTemplate } from "src/api/generated/postgres/db/types/tasks/tables/taskTemplate";
import { IsoDateString } from "src/types/dateTime";
import { TaskSourceRef } from "src/api/generated/tasks/taskSource/taskSourceRef";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace TaskTemplateImportApi {
	export async function getTaskTemplateForImport(args: {
		taskTemplateId: number;
	}): Promise<TaskTemplateImportApi_TaskTemplateForImport> {
		const response = await makeAxiosRequest({
			url: "/api/ext/tasks/taskTemplate/import/getTaskTemplateForImport",
			method: "POST",
			data: {
				taskTemplateId: args.taskTemplateId,
			},
		});
		return response as TaskTemplateImportApi_TaskTemplateForImport;
	}

	export async function importTasksFromTemplate(args: {
		request: TaskTemplateImportApi_ImportTasksFromTemplateRequest;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/tasks/taskTemplate/import/importTasksFromTemplate",
			method: "POST",
			data: {
				request: args.request,
			},
		});
		return response as void;
	}
}

export interface TaskTemplateImportApi_TaskTemplateForImport {
	items: Array<TaskTemplateItem>;
	taskTemplate: TaskTemplate;
}

export interface TaskTemplateImportApi_ImportTasksFromTemplateRequest {
	items: Array<TaskTemplateImportApi_ImportTaskTemplateItemRequest>;
	referenceDate: IsoDateString;
	sourceRef: TaskSourceRef;
}

export interface TaskTemplateImportApi_ImportTaskTemplateItemRequest {
	assignedToUserId: number;
	taskTemplateItemId: number;
}
